import { services } from "../__fixtures__/services";

const useService = ({ type }) => {
  const service = services[type];
  const getItemById = (id) => service.filter((item) => item.id === id)[0];

  return { service, getItemById };
};

export default useService;
